<!-- Concat.vue -->
<template>
	<div class="main-content" v-if="detailInfo">
		<flex-line :is-link="true" :show-border="true" @click.native="$router.push({name:'HomeGoodsConsult',query:{goods_id:detailInfo.goods_id}})">
			<span>商品咨询</span>
		</flex-line>
		</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
export default {
  data () {
    return {}
  },

components:{flexLine},
  computed: {
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo,
      user: state => state.member.info,
      isOnline: state => state.member.isOnline
    })
  },

  watch: {},

  mounted () {
    this.$nextTick(() => {})
  },

  created () {},

  methods: {
    goSingin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    }
  }
}
</script>

<style lang="scss" scoped>

	.main-content{padding:0 $pageSpace;background-color: #fff;}
</style>
